import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import useAxios from "../../../../api/useAxios";

const BodyEditModal = ({ selectedItem, open, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState({
    name: "",
    isUsed: false,
  });
  const instance = useAxios();
  const updateBodyPart = async () => {
    setLoading(true);
    try {
      const response = await instance.put(
        `/body-part/${selectedItem._id}`,
        payload
      );
      handleClose(response.data.data);
    } catch (error) {
      console.log(error);
      handleClose();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPayload(selectedItem);
  }, [selectedItem]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle>
        {" "}
        <div className="modal-header bg-info">
          <h4 className="modal-title">Edit Body Part</h4>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </DialogTitle>
      <DialogContent className="px-5">
        <Stack>
          <Box>
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              value={payload.name}
              onChange={(e) =>
                setPayload((prev) => ({ ...prev, name: e.target.value }))
              }
              className="form-control border border-info"
            />
          </Box>
          <Box>
            <label htmlFor="isUsed">Active</label>
            <input
              type="checkbox"
              id="isUsed"
              checked={payload.isUsed}
              onChange={() =>
                setPayload((prev) => ({ ...prev, isUsed: !payload.isUsed }))
              }
            />
          </Box>
          <Box className="d-flex justify-content-center">
            <Button
              onClick={updateBodyPart}
              startIcon={loading && <CircularProgress size={20} />}
            >
              Save
            </Button>
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default BodyEditModal;
